import React from 'react';
import {Select, SelectProps} from 'tea-component';
import classNames from 'classnames';
import './index.scss';

interface SelectButtonTextProps {
  title: string; // 标题，字符串类型
  content: string; // 内容，字符串类型
  style?: React.CSSProperties; // 可选，自定义样式
  className?: string; // 可选，自定义类名
}

interface SelectOfButtonProps extends SelectProps {
  prefix: string; // 前缀，字符串类型
}

const SelectButtonText: React.FC<SelectButtonTextProps> = ({ title, content, style, className }) => (
  <div style={{ display: 'flex', alignItems: 'center', ...style }} className={classNames('dbl-select-button-wrap', className)}>
    {
      title && (<span title={title} className={'dbl-select-button-text'} style={{ color: '#9B9FB0', marginRight: '8px' }}>{title}</span>)
    }
    <span className={'dbl-select-button-content'}>{content}</span>
  </div>
);

const SelectWithButton: React.FC<SelectOfButtonProps> = ({prefix, className, ...reset}) => (<Select
  {...reset}
  className={classNames('dbl-select-button', className)}
  appearance="button"
  button={(selectedOption) => <SelectButtonText title={prefix} content={selectedOption?.text || ''}/>}
/>);

export default SelectWithButton;